(function () {
  if (window.__PRDGY_COLLECTION_LOAD_MORE_V2__) return;
  window.__PRDGY_COLLECTION_LOAD_MORE_V2__ = true;

  var activeButton = null;
  var activeRequest = null;
  var observer = null;
  var userScrolled = false;
  var autoPaused = false;
  var queued = false;
  var scrollQueued = false;
  var root = document.documentElement;

  function getGrid() {
    return document.querySelector('#ProductGridContainer #product-grid');
  }

  function productKey(item) {
    var link = item.querySelector('a[href*="/products/"]');
    return link ? new URL(link.getAttribute('href'), location.origin).pathname : null;
  }

  function setStatus(button, text) {
    var wrap = button.closest('.prdgy-load-more-wrap');
    var status = wrap && wrap.querySelector('[data-prdgy-load-more-status]');
    if (status) status.textContent = text;
  }

  function current(request) {
    return activeRequest === request && request.button.isConnected && getGrid() === request.grid;
  }

  function nearEnd() {
    if (!userScrolled || autoPaused || !activeButton || activeRequest) return;
    var box = activeButton.getBoundingClientRect();
    if (box.height && box.top < innerHeight + 400 && box.bottom > 0) loadMore(activeButton);
  }

  function synchronize() {
    queued = false;
    var button = document.querySelector('#ProductGridContainer [data-prdgy-load-more]');
    var grid = getGrid();
    if (activeRequest && (activeRequest.grid !== grid || activeRequest.button !== button)) {
      activeRequest.controller.abort();
      activeRequest = null;
    }
    if (button === activeButton) return;
    if (observer) observer.disconnect();
    activeButton = button;
    userScrolled = false;
    autoPaused = false;
    root.classList.remove('prdgy-load-more-failed');
    root.classList.toggle('prdgy-load-more-enabled', Boolean(button && grid));
    if (!button || !grid) return;
    button.dataset.prdgyLoadMoreReady = '2';
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) nearEnd();
      }, { rootMargin: '400px 0px' });
      observer.observe(button);
    }
  }

  function scheduleSync() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(synchronize);
  }

  async function loadMore(button) {
    var grid = getGrid();
    var nextUrl = button.getAttribute('data-next-url');
    if (!grid || !nextUrl || button.disabled || activeRequest) return;
    var url = new URL(nextUrl, location.origin);
    if (url.origin !== location.origin) return;
    if (grid.dataset.id) url.searchParams.set('section_id', grid.dataset.id);
    var request = { button: button, grid: grid, controller: new AbortController() };
    activeRequest = request;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Loading designs…';
    setStatus(button, 'Loading more designs…');
    try {
      var response = await fetch(url.toString(), { credentials: 'same-origin', signal: request.controller.signal });
      if (!response.ok) throw new Error('HTTP ' + response.status);
      var html = await response.text();
      if (!current(request)) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var nextGrid = doc.querySelector('#ProductGridContainer #product-grid');
      if (!nextGrid) throw new Error('Product grid missing');
      var seen = new Set(Array.from(grid.querySelectorAll(':scope > .grid__item')).map(productKey).filter(Boolean));
      var fragment = document.createDocumentFragment();
      var added = 0;
      nextGrid.querySelectorAll(':scope > .grid__item').forEach(function (item) {
        var key = productKey(item);
        if (key && seen.has(key)) return;
        if (key) seen.add(key);
        var imported = document.importNode(item, true);
        [imported].concat(Array.from(imported.querySelectorAll('.scroll-trigger'))).forEach(function (element) {
          if (!element.classList.contains('scroll-trigger')) return;
          element.classList.remove('scroll-trigger--offscreen');
          element.classList.add('scroll-trigger--cancel');
        });
        fragment.appendChild(imported);
        added += 1;
      });
      grid.appendChild(fragment);
      var nextButton = doc.querySelector('[data-prdgy-load-more]');
      var next = nextButton && nextButton.getAttribute('data-next-url');
      if (next) {
        if (new URL(next, location.origin).href === new URL(nextUrl, location.origin).href) throw new Error('Pagination did not advance');
        button.setAttribute('data-next-url', next);
        button.disabled = false;
        button.textContent = 'Load more designs';
        setStatus(button, added + ' fresh designs added — keep exploring.');
      } else {
        button.removeAttribute('data-next-url');
        button.textContent = 'All designs loaded';
        button.disabled = true;
        setStatus(button, 'All designs loaded.');
        if (observer) observer.disconnect();
      }
      root.classList.remove('prdgy-load-more-failed');
      window.dispatchEvent(new CustomEvent('prdgy:collection:loaded', { detail: { added: added } }));
    } catch (error) {
      if (!current(request) || error.name === 'AbortError') return;
      autoPaused = true;
      button.disabled = false;
      button.textContent = 'Load more designs';
      setStatus(button, 'Could not load more. Use page links below.');
      root.classList.add('prdgy-load-more-failed');
      console.warn('[PRDGY load more]', error);
    } finally {
      if (current(request)) {
        button.removeAttribute('aria-busy');
        activeRequest = null;
      }
    }
  }

  function start() {
    var container = document.querySelector('#ProductGridContainer');
    if (!container) return;
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-prdgy-load-more]');
      if (!button || !container.contains(button)) return;
      event.preventDefault();
      loadMore(button);
    });
    function scheduleNearEnd() {
      if (scrollQueued) return;
      scrollQueued = true;
      requestAnimationFrame(function () {
        scrollQueued = false;
        nearEnd();
      });
    }
    function userScroll() {
      userScrolled = true;
      scheduleNearEnd();
    }
    window.addEventListener('wheel', userScroll, { passive: true });
    window.addEventListener('touchmove', userScroll, { passive: true });
    window.addEventListener('keydown', function (event) {
      if (event.target.closest('input, textarea, select, [contenteditable="true"]')) return;
      if (['ArrowDown', 'PageDown', 'End', ' '].includes(event.key)) userScroll();
    });
    window.addEventListener('scroll', scheduleNearEnd, { passive: true });
    new MutationObserver(scheduleSync).observe(container, { childList: true, subtree: true });
    synchronize();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
